import React from 'react';
import { createContainer } from 'unstated-next';

const useUserName = () => {
    const [userName, setUserName] = React.useState(localStorage.getItem('userName') || '');

    React.useEffect(() => {
        localStorage.setItem('userName', userName);
    }, [userName]);

    return {
        userName,
        setUserName,
    };
};

export const UserName = createContainer(useUserName);

